/* eslint-disable no-undef */
/* eslint-disable space-before-function-paren */
/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { Messager, LinkButton } from "rc-easyui";

import {
  Card,
  CardBody,
  FormGroup,
  Form,
  Label,
  Input,
  Col,
  Button,
  CardHeader,
} from "reactstrap";
import ReCAPTCHA from "react-google-recaptcha";
import "./Login.css";
import { setCookie, getCookie } from "../../helpers/cookieHelper";
import { APP_NAME, API_URL, BASE_URL, dataSitekey, isSelenium } from "../../constants";
import TitleComponent from "../../helpers/TitleComponent";

const axios = require("axios");

export default class Login extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.captchaChange = this.captchaChange.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.handleUsernameChange = this.handleUsernameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.getRolesAndAuthority = this.getRolesAndAuthority.bind(this);

    this.recaptchaRef = React.createRef();
    this.state = {
      username: "",
      password: "",
      captcha: "",
      usernameErrorMsg: "",
      passwordErrorMsg: "",
      captchaErrorMsg: "",
      isLoading: false,
    };
  }
  componentDidMount() {
    TitleComponent("Login");
  }

  handleUsernameChange(e) {
    if (e.target.value.length === 0) {
      this.setState({
        username: e.target.value,
        usernameErrorMsg: "Username field is required",
      });
    } else {
      this.setState({
        username: e.target.value,
        usernameErrorMsg: "",
      });
    }
  }

  handlePasswordChange(e) {
    const password = e.target.value;
    const regx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,}$)/;
    if (!regx.test(password)) {
      this.setState({
        password: password,
        passwordErrorMsg: "Password criteria doesnt match",
      });
      return;
    }
    if (password.length === 0) {
      this.setState({
        password: password,
        passwordErrorMsg: "Password field is required",
      });
    } else {
      this.setState({
        password: password,
        passwordErrorMsg: "",
      });
    }
  }

  handleLogin() {
    const {
      username,
      password,
      usernameErrorMsg,
      passwordErrorMsg,
      captcha,
    } = this.state;
    if (username.length === 0) {
      this.setState({
        usernameErrorMsg: "Username field is required",
      });
      return;
    }
    if (password.length === 0) {
      this.setState({
        passwordErrorMsg: "Password field is required",
      });
      return;
    }
    if (captcha.length === 0 && isSelenium === "false") {
      this.setState({
        captchaErrorMsg: "Captcha field is required",
      });
      return;
    }

    if (usernameErrorMsg.length === 0 && passwordErrorMsg.length === 0) {
      this.setState({
        isLoading: true,
      });

      // if (captcha.length < 1 && isSelenium === "false") {
      //   this.setState({ isLoading: false })
      //   this.messager.alert({
      //     title: "info",
      //     icon: "info",
      //     msg: "Please Fill the captcha",
      //     // reload: false,
      //   });
      //   return;
      // }


      var data = {
        username: username,
        password: password,
        "g-recaptcha-response": captcha,
        grant_type: "password",
      };

      var auth = {
        auth: {
          username: "web",
          password: "web",
        },
      };

      var loginUrl =
        API_URL +
        "oauth/token" +
        "?grant_type=password" +
        "&username=" +
        username +
        "&password=" +
        password;

      axios
        .post(loginUrl, data, auth, {
          headers: { "Access-Control-Allow-Origin": "*" },
        })
        .then((response) => {
          this.handleResponse(response);
        })
        .catch((err, code) => {
          this.setState({
            isLoading: false,
          });

          var response = err["response"];
          if (response === undefined) {
            this.messager.alert({
              title: "Error",
              msg: "Internal Server Error",
            });
          } else {
            this.messager.alert({
              title: "Error",
              msg: "Username or Password doesnt match",
            });
            // if (response.status === 401) {
            //   this.messager.alert({
            //     title: "Error",
            //     msg: "Username or Password doesnt match",
            //   });
            // } else {
            //   this.messager.alert({
            //     title: "Error",
            //     msg: "Internal Server Error",
            //   });
            // }
          }
        });
    }
  }

  getRolesAndAuthority(expires_in) {
    var access_token = getCookie("access_token");

    var auth = {
      auth: {
        username: "web",
        password: "web",
      },
    };

    axios
      .post(
        API_URL + "oauth/check_token?token=" + access_token,
        {
          token: access_token,
        },
        auth
      )
      .then((response) => {

        if (response.status === 200) {
          this.setState({
            isLoading: false,
          });

          this.messager.alert({
            title: "Success",
            msg: "Redirecting....",
          });

          setCookie("permission", JSON.stringify(response.data.authorities));
          setCookie("username", response.data.user_name);
          window.location = BASE_URL + "dashboard";
        }
      })
      .catch((error) => {
        this.messager.alert({
          title: "Error",
          msg: "Internal Server Error",
        });
      });
  }

  handleResponse(response) {
    if (response.status === 200) {
      var expires_in = response.data.expires_in;
      // var expires_in = 30;
      setCookie("access_token", response.data.access_token, expires_in);
      setCookie("token_type", response.data.token_type);
      setCookie("refresh_token", response.data.refresh_token);
      setCookie("expires_in", response.data.expires_in, expires_in);
      this.getRolesAndAuthority(expires_in);
    } else {
      this.messager.alert({
        title: "Error",
        msg: "Username or Password doesnt match",
      });
    }
  }

  captchaChange(value) {
    this.setState({
      captcha: value,
      captchaErrorMsg: value.length > 0 ? "" : "Captcha field is required",
    });
  }

  render() {

    var loading = this.state.isLoading;
    return (
      <div className='container' style={{ marginTop: "10%" }}>
        <div
          className='loadingmodel'
          style={{ display: loading ? "block" : "none" }}
        ></div>
        <Messager
          ref={(ref) => (this.messager = ref)}
          showHeader={false}
          borderType='none'
          content={({ title, msg, buttons }) => (
            <div className='alert-content'>
              <h2>{title}</h2>
              <p>{msg}</p>
              <div className='m-buttons'>
                {buttons.map((button, index) => (
                  <LinkButton
                    key={index}
                    text={button.text}
                    onClick={() => {
                      this.messager.close(button);
                      window.location.reload();
                    }}
                  />
                ))}
              </div>
            </div>
          )}
        />
        <div className='row'>
          <div className='col-5 offset-3'>
            <Card style={{ background: "rgba(85, 185, 180, 0.57)" }}>
              <CardHeader color='primary'>
                <h3 className='text-white text-center'>Login</h3>
              </CardHeader>
              <CardBody>
                <Form autoComplete='off'>
                  <FormGroup row>
                    <Label
                      className='text-white'
                      for='username'
                      style={{ paddingLeft: 15 }}
                    >
                      Username
                    </Label>
                    <Col sm={12}>
                      <Input
                        autoComplete='off'
                        type='name'
                        name='username'
                        id='username'
                        placeholder='Username'
                        style={{ display: "none" }}
                      />
                      <Input
                        autoComplete='off'
                        type='name'
                        id='username'
                        placeholder='Username'
                        onKeyUp={this.onKeyUpUsername}
                        value={this.state.username}
                        onChange={this.handleUsernameChange}
                        readOnly={true}
                        onFocus={(e) => e.target.removeAttribute("readonly")}
                      />
                      <span className='errorMsg'>
                        {this.state.usernameErrorMsg}
                      </span>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Label
                      className='text-white'
                      for='password'
                      style={{ paddingLeft: 15 }}
                    >
                      Password
                    </Label>
                    <Col sm={12}>
                      <Input autoComplete='off' type='tel' hidden />
                      <Input
                        autocomplete='off'
                        type='password'
                        id='password'
                        value={this.state.password}
                        onChange={this.handlePasswordChange}
                        placeholder='*********'
                        readOnly={true}
                        onFocus={(e) => e.target.removeAttribute("readonly")}
                      />
                      <span className='errorMsg'>
                        {this.state.passwordErrorMsg}
                      </span>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col sm={12}>
                      <ReCAPTCHA
                        ref={this.recaptchaRef}
                        sitekey={dataSitekey}
                        onChange={this.captchaChange}
                      />
                      <span className='errorMsg'>
                        {this.state.captchaErrorMsg}
                      </span>
                    </Col>
                  </FormGroup>
                </Form>
                <center>
                  <Button
                    type='button'
                    color='primary'
                    data-testid='loginbtn'
                    onClick={this.handleLogin.bind(this)}
                  >
                    Login
                  </Button>
                </center>
                &nbsp;&nbsp;&nbsp;
                {/* <Button color='danger' onChange=>Clear</Button> */}
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}
